export default {
  PLAN_APPLY:"01", //信息完善中
  PLAN_FAIL:"02", //提交失败
  PLAN_AUDIT:"03", //信息审核中
  
  CANCEL:"11", //项目撤销

  INITATION_WAIT:"20", //项目立项中
  INITATION_AUDIT:"21", //立项审核中

  IDEA_WAIT:"30", //方案制作中
  IDEA_AUDIT:"31", //方案审核中

  PURCHASE_WAIT:"40", //采购中
  PURCHASE_AUDIT:"41", //采购审核中

  SIGN_WAIT:"50", //签约中
  SIGN_AUDIT:"51", //合同审核中

  SERVICING:"70", //服务中
  RENEWAL:"80", //续保中

  END:"90", //项目结束
}